export default "__VITE_ASSET__6689ab43__"